import React from 'react';
import { Alert } from '@mui/material';

/** Shown at the top of a Settings tab the current role may look at but not change. */
export default function ViewOnlyNotice({ children }) {
  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      View only — {children || 'your role can see these settings but cannot change them.'}
    </Alert>
  );
}
